var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[(_vm.$route.meta.layout == 'admin')?_c('Admin'):_vm._e(),(_vm.$route.meta.layout == 'none')?_c('None'):_vm._e(),(_vm.$route.meta.layout == 'home')?_c('Home'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }